<
<template>
  <div>
    <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="false"
    ></loading>

    <div v-if="allReportPermissions.length > 0">
      <div class="mx-2">

        <b-dropdown class="reportButton" variant="primary" right>
          <template v-slot:button-content>
            <i class="far fa-file-alt"></i>

            <i
                class="fa fa-check-square checkboxIcon"
                v-if="guiLocation === 'GRADIVO_IZBOR'"
            ></i>
          </template>
          <b-dropdown-item
              v-for="(item, index) in reportTypeOptions"
              class="py-1 text-left"
              :key="'report_' + index"
              :id="'report_' + item.reportType"
              v-if="(item.reportType !== 'OIIU_BRISANJE' && $globalFunctions.checkForPermission(item.permission)) || (item.reportType === 'OIIU_BRISANJE' && $globalFunctions.checkForPermission(item.permission) && checkIfQueryContainsGhosted)"
              @click="
              (e) => {
                e.preventDefault();
                beforeGenerateReport(item);
                selectedReport = item;
              }
            "
          >
            {{ item.name }}
          </b-dropdown-item>
          <b-dropdown-item
              v-for="(item, index) in reportFileTypOptions"
              class="py-1 text-left"
              :key="'report_filesystem_' + index"
              :id="'report_filesystem_' + item.reportType"
              v-if="$globalFunctions.checkForPermission(item.permission) && guiLocation === 'OSTALO'"
              @click="
              (e) => {
                e.preventDefault();
                beforeGenerateReport(item);
                selectedReport = item;
              }
            "
          >
            {{ item.name }}
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <b-modal
          ref="setCourt-modal"
          :title="$t('text.generateReportButton.setCourtModal.title')"
          size="lg"
          @hidden="closeModal()"
      >

        <loading
            :active.sync="isLoadingInModal"
            :can-cancel="false"
            :is-full-page="false"
        ></loading>


        <div class="form-condensed">
          <div class="row">
            <div class="col-md-12"
                 v-if="$globalFunctions.checkForPermission('ARHIV_RS') || reportType === 'OIIU_BRISANJE' || reportType === 'NAPAKE' || reportType === 'REVIZIJSKA_SLED_UPORABNIK' || reportType === 'REVIZIJSKA_SLED_SIFRANTI' || reportType === 'REVIZIJSKA_SLED_NEOMEJENO' || reportType === 'REVIZIJSKA_SLED_ZADEVA' || reportType === 'REVIZIJSKA_SLED_RAZRED'">

              <div
                  class="form-group"
                  v-if="reportType !== 'OIIU_BRISANJE' && reportType !== 'NAPAKE'"
              >
                {{ $t('text.generateReportButton.setCourtModal.prompt1') }}
                <b>{{ selectedReport ? selectedReport.name : "" }}</b><span
                  v-if="reportType === 'GRADIVO_ROKI_HRAMBE' || reportType === 'GRADIVO_DOSTOP'"> {{
                  $t('text.generateReportButton.setCourtModal.prompt2')
                }}
                                <b>{{
                                    $globalFunctions.getReadableCodeListValueFromProperty(
                                        allMetadataOptions,
                                        "EH:sodisce",
                                        selectedCourt
                                    )
                                  }}</b
                                ></span>.
              </div>

              <div
                  class="form-group"
                  v-if="reportType === 'NAPAKE' || reportType === 'REVIZIJSKA_SLED_UPORABNIK' || reportType === 'REVIZIJSKA_SLED_SIFRANTI' || reportType === 'REVIZIJSKA_SLED_NEOMEJENO' || reportType === 'REVIZIJSKA_SLED_ZADEVA' || reportType === 'REVIZIJSKA_SLED_RAZRED'">
                <label :for="'dateFrom'">{{ $t('text.generateReportButton.setCourtModal.dateFrom') }}</label>

                <VueCtkDateTimePicker
                    id="dateFrom"
                    format="YYYY-MM-DDTHH:mm:ssZ"
                    :range="false"
                    :no-label="true"
                    :auto-close="false"
                    formatted="DD.MM.YYYY, HH:mm"
                    v-model="dateFrom"
                    :only-date="false"
                    :custom-shortcuts="customShortcuts"
                    :locale="$t('text.globals.datePickerLocale')"
                    :button-now-translation="$t('text.globals.now')"
                />
              </div>

              <div
                  class="form-group"
                  v-if="reportType === 'NAPAKE' || reportType === 'REVIZIJSKA_SLED_UPORABNIK' || reportType === 'REVIZIJSKA_SLED_SIFRANTI' || reportType === 'REVIZIJSKA_SLED_NEOMEJENO' || reportType === 'REVIZIJSKA_SLED_ZADEVA' || reportType === 'REVIZIJSKA_SLED_RAZRED'">
                <label :for="'dateTo'">{{ $t('text.generateReportButton.setCourtModal.dateTo') }}</label>

                <VueCtkDateTimePicker
                    id="dateTo"
                    format="YYYY-MM-DDTHH:mm:ssZ"
                    :range="false"
                    :no-label="true"
                    :auto-close="false"
                    formatted="DD.MM.YYYY, HH:mm"
                    v-model="dateTo"
                    :only-date="false"
                    :custom-shortcuts="customShortcuts"
                    :locale="$t('text.globals.datePickerLocale')"
                    :button-now-translation="$t('text.globals.now')"
                />
              </div>

              <div
                  class="form-group"
                  v-if="reportType === 'REVIZIJSKA_SLED_UPORABNIK'">
                <label :for="'user'">{{ $t('text.generateReportButton.setCourtModal.user') }}</label>

                <input type="text" class="form-control" id="user"
                       name="user"
                       v-model="user"
                >
              </div>

              <div
                  class="form-group"
                  v-if="reportType === 'REVIZIJSKA_SLED_ZADEVA'">
                <label :for="'stevilkaZadeve'">{{
                    $t('text.generateReportButton.setCourtModal.stevilkaZadeve')
                  }}</label>

                <input type="text" class="form-control" id="user"
                       name="stevilkaZadeve"
                       v-model="stevilkaZadeve"
                >
              </div>

              <div
                  class="form-group"
                  v-if="reportType === 'REVIZIJSKA_SLED_SIFRANTI'">
                <label :for="'register'">{{ $t('text.auditLog.registerAuditLog.register') }}</label>

                <v-select
                    class="form-control"
                    id="register"
                    name="register"
                    label="name"
                    :options="registerOptions"
                    :reduce="item => item.id"
                    v-model="selectedRegisterOption"
                >
                  <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                </v-select>
              </div>
            </div>

            <div class="col-md-12">
              <div
                  class="form-group"
                  v-if="reportType === 'REVIZIJSKA_SLED_RAZRED'">
                <label :for="'register'">{{ $t('text.generateReportButton.setCourtModal.classificationClass') }}</label>

                <v-select
                    class="form-control"
                    :options="_getClassificationPlanWithRoot"
                    v-model="selectedClassificationClass"
                    :filter-by="knSearchFilter"
                    :reduce="item => item.uuid"
                    label="classificationLabelName"
                >
                  <span slot="no-options">{{ $t("text.globals.noOptions") }}</span>

                  <template slot="option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                    {{ option.classificationLabelName }}
                  </template>
                  <template slot="selected-option" slot-scope="option">
                <span v-if="option.classificationLabel !== 'none'"
                >({{ option.classificationLabel }})</span
                >
                    {{ option.classificationLabelName }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="col-md-12" v-if="reportType === 'PRETECENI_DATUM'">
              <div
                  class="form-group">
                <label :for="'date'">{{ $t('text.generateReportButton.setCourtModal.date') }}</label>

                <VueCtkDateTimePicker
                    id="date"
                    format="YYYY-MM-DD"
                    :range="false"
                    :no-label="true"
                    :auto-close="false"
                    formatted="DD.MM.YYYY"
                    v-model="date"
                    :only-date="true"
                    :custom-shortcuts="customShortcuts"
                    :locale="$t('text.globals.datePickerLocale')"
                    :button-now-translation="$t('text.globals.now')"
                />
              </div>

<!--              <div class="form-group" v-if="courts.length > 0 && (courts.indexOf('ALL') === -1 && courts[0] !== null)">-->
<!--                <label :for="'sodisce'">{{$t('text.globals.court')}}</label>-->

<!--                <v-select :options="options_sodisce"-->
<!--                          :reduce="item => item.id"-->
<!--                          id="sodisce"-->
<!--                          label="description"-->
<!--                          class="form-control"-->
<!--                          v-model="sodisce"-->
<!--                >-->
<!--                  <span slot="no-options">{{$t('text.globals.noOptions')}}</span>-->
<!--                </v-select>-->
<!--              </div>-->
            </div>

            <!-- do not show description field for reports that are stored on filesystem -->
            <div class="col-md-12"
                 v-if="reportType !== 'REVIZIJSKA_SLED_UPORABNIK' && reportType !== 'REVIZIJSKA_SLED_SIFRANTI' && reportType !== 'REVIZIJSKA_SLED_NEOMEJENO' && reportType !== 'REVIZIJSKA_SLED_ZADEVA' && reportType !== 'REVIZIJSKA_SLED_RAZRED'">

              <div class="form-group">
                <label for="description">{{ $t('text.generateReportButton.setCourtModal.reportDescription') }}</label>
                <textarea rows="4" class="form-control" id="description"
                          aria-describedby="description"
                          v-model="description"
                          name="description"
                />
              </div>
            </div>

            <div class="col-md-12" v-if="(reportType !== 'GRADIVO_ROKI_HRAMBE' && reportType !== 'STAT_ROKI_HRAMBE' &&
                        (guiLocation === 'GRADIVO_ISKANJE' && (reportType !== 'GRADIVO' && reportType !== 'GRADIVO_DOSTOP' && reportType !== 'GRADIVO_ROKI_HRAMBE')) ||
                        (guiLocation === 'PRETECENI_DATUM' && reportType !== 'PRETECENI_DATUM') ||
                        (guiLocation === 'OIIU_DODELJENO' ||  guiLocation === 'OIIU_KANDIDATI_IZROCITEV' ||  guiLocation === 'OIIU_PREGLEDANO_ARHIV' ||  guiLocation === 'OIIU_PRIMERNO_ARHIV' ||  guiLocation === 'OIIU_PREDLAGANO_UNICENJE')) && this.$store.getters.getSelectedDocuments.length > 0">
              <b-alert show variant="warning" class="mb-0">
                <i class="fa fa-exclamation-triangle"></i> {{ $t('text.generateReportButton.reportContainsSearchResultsWarning') }}
              </b-alert>
            </div>

            <div class="col-md-12" v-if="reportType === 'STAT_ROKI_HRAMBE'">
              <b-alert show variant="warning" class="mb-0">
                <i class="fa fa-exclamation-triangle"></i> {{ $t('text.generateReportButton.reportGradivoRokiHrambeWarning') }}
              </b-alert>
            </div>

            <div class="col-md-12" v-if="guiLocation === 'GRADIVO_IZBOR'">
              <b-alert show variant="warning" class="mb-0">
                <i class="fa fa-exclamation-triangle"></i> {{ $t('text.generateReportButton.reportContainsSelectionWarning') }}
              </b-alert>
            </div>

          </div>
        </div>

        <div slot="modal-footer" class="w-100">
          <b-button
              id="reassignBtn"
              variant="primary"
              class="float-right"
              @click="generateReport()">
            {{ $t('text.generateReportButton.setCourtModal.sendRequestForReportCreation') }}
          </b-button>

          <b-button
              id="closeReassingModal"
              variant="default"
              class="float-right"
              @click="closeModal">
            {{ $t('text.globals.cancel') }}
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import convert from "xml-js";
import flatten from "flat";

export default {
  name: "GenerateReportButton",
  components: {
    Loading,
    vSelect,
  },
  props: [
    "id",
    "guiLocation",
    "query",
    "serverParams",
    "searchFieldsText",
    "filtersQuery",
    "searchType",
    "context",
  ],
  data() {
    return {
      permissions: [],
      allMetadataOptions: [],
      courts: [],
      options_sodisce: [],
      sodisce: null,
      reportTypeOptions: [],
      reportFileTypOptions: [],
      selectedReport: null,
      selectedCourt: null,
      dateFrom: null,
      dateTo: null,
      date: null,
      user: null,
      stevilkaZadeve: null,
      reportType: null,
      isLoading: false,
      customShortcuts: this.$t("text.globals.customDatePickerShortcuts"),
      allReportPermissions: [],
      description: null,
      registerOptions: this.$t('text.registry.registerOptions'),
      selectedRegisterOption: null,
      rokHrambe: null,
      classificationPlan: this.$store.getters.getClassificationPlan,
      selectedClassificationClass: null,
      isLoadingInModal: false,
      knSearchFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.classificationLabel.toLowerCase().indexOf(temp) > -1 ||
            option.classificationLabelName.toLowerCase().indexOf(temp) > -1
      }
    };
  },

  computed: {
    _getClassificationPlanWithRoot() {

      let classificationPlan = _.cloneDeep(
          this.$store.getters.getClassificationPlan
      );

      let flattenClassificationPlan = flatten(classificationPlan);
      let classificationPlanToReturn = [];

      // retrieve classificationLabel & classificationLabelName from flatenned classificationPlan
      _.map(flattenClassificationPlan, function (val, key, idx) {
        if (key.indexOf('classificationLabelName') > -1) {
          let index = 0;
          let objIndex = Object.keys(flattenClassificationPlan).indexOf(key);

          if ((Object.keys(flattenClassificationPlan)[objIndex - 2].indexOf('classificationLabel') > -1) && (typeof val === 'string')) {
            let item = {
              classificationLabelName: val,
              classificationLabel: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 2]],
              uuid: flattenClassificationPlan[Object.keys(flattenClassificationPlan)[objIndex - 3]],
            }
            classificationPlanToReturn.push(item);
          }
        }
      });

      console.log("classificationPlanToReturn", classificationPlanToReturn);
      return classificationPlanToReturn;
    },
    checkIfQueryContainsGhosted() {
      return this.query.includes('AND ASPECT:"rma:ghosted"') || this.query.includes('(ASPECT:\"rma:ghosted\" )');
    },
  },
  destroyed() {
    const _this = this;
    console.log("GenerateButton destroyed - clear list of selected documents!");
    _this.$store.dispatch("setSelectedDocuments", []);
    _this.$forceUpdate();
  },
  mounted() {
    const _this = this;
    _this.isLoading = true;

    let p1 = _this.$store.dispatch("retrievePermissions");
    let p2 = _this.$store.dispatch("retrieveAllMetadataOptions");
    let p3 = _this.$store.dispatch("retrieveReportTypeOptions");
    let p4 = _this.$store.dispatch("retrieveCodeListProperties");

    Promise.all([p1, p2, p3, p4]).then(() => {
      _this.permissions = _this.$store.getters.getPermissions;
      _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;
      _this.reportTypeOptions = _.filter(
          this.$store.getters.getReportTypeOptions,
          {guiLocation: _this.guiLocation}
      );
      _this.reportFileTypOptions = _.filter(
          this.$store.getters.getReportTypeOptions,
          {guiLocation: 'AUDIT_TIPSKA_POROCILA'}
      );



      if(this.guiLocation === 'PRETECENI_DATUM') {

        _.each(_this.allMetadataOptions, function (val, key) {
          let property = val.property;

          if(property === 'EH:sodisce') {
            _this.options_sodisce = val.body;
          }
        });

        if(_this.id !== "pretecenRokHrambeBtn2"){
          _this.reportTypeOptions = _this.reportTypeOptions.concat(_.filter(
              this.$store.getters.getReportTypeOptions,
              {guiLocation: "OIIU_PRETECENO"}
          ));
        }

        console.log("_this.options_sodisce", _this.options_sodisce);
      }
      _this.isLoading = false;

      console.log("reportTypeOptions", _this.reportTypeOptions);

      // check if user has any permission for reports
      _.map(_this.reportTypeOptions, function (val) {
        if (_this.$globalFunctions.checkForPermission(val.permission)) {
          _this.allReportPermissions.push(val.permission);
        }
      });
    });
  },
  methods: {
    closeModal: function () {
      const _this = this;

      if (_this.$refs["setCourt-modal"]) {
        _this.dateFrom = null;
        _this.dateTo = null;
        _this.date = null;
        _this.sodisce = null;
        _this.description = null;
        _this.selectedCourt = null;
        _this.selectedClassificationClass = null;
        _this.selectedRegisterOption = null;
        _this.user = null;
        _this.stevilkaZadeve = null;
        _this.$refs["setCourt-modal"].hide();
      }
    },

    generateReport() {
      const _this = this;

      let data = {
        reportType: _this.reportType,
        courtId: _this.selectedCourt,
        nodeIds: _this.$store.getters.getSelectedDocuments,
        description: _this.description
      };

      console.log("DATA", data);

      // if(_this.description) {
      //     data.description = _this.description;
      // }

      console.log("filtersQuery", _this.filtersQuery);
      // parse sodišče info from fitlers query

      if (_this.guiLocation === "GRADIVO_ISKANJE" || _this.guiLocation === 'GRADIVO_IZBOR' || _this.guiLocation === 'OIIU_DODELJENO' || _this.reportType === 'OIIU_PRETECENO'
          || _this.guiLocation === 'OIIU_KANDIDATI_IZROCITEV' || _this.guiLocation === 'OIIU_PREGLEDANO_ARHIV'
          || _this.guiLocation === 'OIIU_PRIMERNO_ARHIV' || _this.guiLocation === 'OIIU_PREDLAGANO_UNICENJE' || _this.guiLocation === 'BRISANJE') {

        console.log("HERE!!!!!!------->", _this.filtersQuery);
        let sort = _this.serverParams.sort;
        _.map(sort, function (val, key) {
          sort[key] = {
            ascending: val.ascending,
            field: val.field,
          };
        });

        data.query = {
          aftsQuery: _this.query ? _this.query : "",
          sortList: sort,
          explanationList: [],
        };

        console.log("filterFields", _this.filterFields);
        console.log("searchType", _this.searchType);
        console.log("query", _this.query);
        console.log("_this.searchFieldsText", _this.searchFieldsText)

        if (_this.searchType == this.$t('text.documentSearch.documentSearchFullText.title')) {
          if(_this.searchFieldsText) {
            data.query.explanationList = [
              {operator: '', parameter: '', value: _this.searchFieldsText},
            ];
          }
          else {
            data.query.explanationList = [];
          }
        } else if (_this.searchType == this.$t('text.documentSearch.documentSearchDetailed.title')) {
          // console.log("iskanje po metapodatkih start", data.query.explanationList);
          let paramPosition = 0;

          // data.query.explanationList = [{operator: '', parameter: _this.searchType, value: ''}];

          if (_this.searchFieldsText[0].parameter) {
            data.query.explanationList.push({
              operator: '',
              parameter: _this.searchFieldsText[0].parameter,
              value: _this.searchFieldsText[0].value
                  ? JSON.stringify(_this.searchFieldsText[0].value)
                  : "",
            });

            if (_this.searchFieldsText[0].vpisniki.length > 0) {
              let vpisnikiQuery = '';
              _.each(_this.searchFieldsText[0].vpisniki, function (val, idx) {
                vpisnikiQuery += (idx === 0 ? ' IN ' : ' ALI ') + _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, "EH:oznaka_vpisnika", val) + '\"';
              });
              let explanationsListLength = data.query.explanationList.length;
              data.query.explanationList[explanationsListLength -1].value = data.query.explanationList[explanationsListLength -1].value + vpisnikiQuery;
            }


          } else {
            if(data.query.explanationList[0]) {
              data.query.explanationList[0].value = "Ni parametrov";
            } else {
              data.query.explanationList = [{value: "Ni parametrov"}];
            }
          }


          if (_this.searchFieldsText[1].parameter) {
            data.query.explanationList.push({
              operator: _this.searchFieldsText[0].operator
                  ? _this.translateOperator(_this.searchFieldsText[0].operator)
                  : '',
              parameter: _this.searchFieldsText[1].parameter
                  ? _this.searchFieldsText[1].parameter
                  : null,
              value: _this.searchFieldsText[1].value
                  ? JSON.stringify(_this.searchFieldsText[1].value)
                  : null,
            });

            if (_this.searchFieldsText[1].vpisniki.length > 0) {
              let vpisnikiQuery = '';
              _.each(_this.searchFieldsText[1].vpisniki, function (val, idx) {
                vpisnikiQuery += (idx === 0 ? ' IN ' : ' ALI ') + _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, "EH:oznaka_vpisnika", val) + '\"';
              });
              let explanationsListLength = data.query.explanationList.length;
              data.query.explanationList[explanationsListLength -1].value = data.query.explanationList[explanationsListLength -1].value + vpisnikiQuery;
            }
          }

          if (_this.searchFieldsText[2].parameter) {
            data.query.explanationList.push({
              operator: _this.searchFieldsText[1].operator
                  ? _this.translateOperator(_this.searchFieldsText[1].operator)
                  : '',
              parameter: _this.searchFieldsText[2].parameter
                  ? _this.searchFieldsText[2].parameter
                  : null,
              value: _this.searchFieldsText[2].value
                  ? JSON.stringify(_this.searchFieldsText[2].value)
                  : null,
            });

            if (_this.searchFieldsText[2].vpisniki.length > 0) {
              let vpisnikiQuery = '';
              _.each(_this.searchFieldsText[2].vpisniki, function (val, idx) {
                vpisnikiQuery += (idx === 0 ? ' IN ' : ' ALI ') + _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, "EH:oznaka_vpisnika", val) + '\"';
              });
              let explanationsListLength = data.query.explanationList.length;
              data.query.explanationList[explanationsListLength -1].value = data.query.explanationList[explanationsListLength -1].value + vpisnikiQuery;
            }
          }

          // console.log("iskanje po metapodatkih end", data.query.explanationList);

        } else if(_this.searchType === "Gradivo s pretečenim rokom hrambe" || _this.searchType === "Gradivo, dodeljeno v pregled"
            || _this.searchType === "Gradivo, potrjeno za izročitev državnemu arhivu" || _this.searchType === "Gradivo, izbrano za izročitev državnemu arhivu"
            || _this.searchType === "Gradivo, primerno za izročitev državnemu arhivu" || _this.searchType === "Gradivo, predlagano za uničenje" || _this.searchType === "Gradivo, potrjeno za uničenje") {

          // console.log("hello!!!", _this.searchFieldsText);
          // console.log("reports -> allMetadataOptions ----> ", this.allMetadataOptions)

          let anySearchParams = false;

          let iter = 0;
          for (let key of Object.keys(_this.searchFieldsText)) {

            if(_this.searchFieldsText[key] !== "" && _this.searchFieldsText[key] !== null) {
              anySearchParams = true;

              data.query.explanationList.push({
                operator: iter == 0 ? '' : _this.translateOperator('AND'),
                parameter: 'EH:' + key,
                value: _this.searchFieldsText[key] !== "" && _this.searchFieldsText[key] !== null
                    ? JSON.stringify(_this.searchFieldsText[key])
                    : "",
              });
              iter++;
            }

          }

//          if(!anySearchParams) {
//            data.query.explanationList = [{operator: '', parameter: '', value: '-'}];
//          }

        } else {

          data.query.explanationList = [{
            parameter: _this.searchType,
            value: _this.searchFieldsText ? _this.searchFieldsText : ''
          }];

          _.forOwn(_this.filterFields, function (value, key) {
            if (value != '' && value != null) {
              data.query.explanationList.push({
                parameter: 'EH:' + key,
                value: value
              });
            }
          });

        }

        _.map(_this.filtersQuery, function (val, key) {

          console.log("val", val);

          let occurrences = (val.match(/:/g) || []).length;
          console.log("occurrences", occurrences);

          if (occurrences === 1) {
            data.query.explanationList.push({
              operator: "IN",
              parameter: val.split(":")[0],
              value: val.split(":")[1].replace(/\"/g, ""),
            });
          } else if (occurrences > 1) {
            data.query.explanationList.push({
              operator: "IN",
              parameter: val.split(":")[0] + ":" + val.split(":")[1],
              value: val.split(":")[2].replace(/\"/g, ""),
            });
          }
        });

      } else if (_this.guiLocation === "OSTALO") {

        if ((!_this.dateFrom || !_this.dateTo) && (_this.reportType != 'STAT_LOKACIJE' && _this.reportType != 'STAT_LOKACIJE_STEVILO' && _this.reportType != 'STAT_MIMETYPE')) {
          Vue.$toast.open({
            message: this.$t('text.generateReportButton.dateFromAndDateToAreRequiredFieldsToast.message'),
            type: 'error',
            position: 'top-right'
          });
          return;
        }

        data.from = _this
            .moment(_this.dateFrom, "YYYY-MM-DDTHH:mm:ssZ")
            .local()
            .format("YYYY-MM-DDTHH:mm:ssZ");
        data.to = _this
            .moment(_this.dateTo, "YYYY-MM-DDTHH:mm:ssZ")
            .local()
            .format("YYYY-MM-DDTHH:mm:ssZ");
      }


      // human readable explanation lists

      // console.log("explanationList", _.cloneDeep(data.query.explanationList));

      if (data.query && data.query.explanationList) {
        _.map(data.query.explanationList, function (val, key) {

          let _val = val;


          let _value = val.value.replace(/['"]+/g, '');
          //
          // console.log("_value", _value);
          // console.log("_parameter", val.parameter);
          // console.log("typeof _value", typeof _value);



          if (_value && _value !== '' && typeof val.value === 'string' && val.value.indexOf('{') === -1) {
            if (_value === "true") {
              _value = 'DA';
              _val.value = _value;
            } else if (_value === "false") {
              _value = 'NE';
              _val.value = _value;
            } else {
              _val.value = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, val.parameter, _value);
            }
          } else if (_val.value.indexOf('{') !== -1) {

            console.log("DATE", _value);

            let startDate = /start:(.+?)(,|})/g.exec(_value)[1].split("-");
            let endDate = /end:(.+?)(,|})/g.exec(_value)[1].split("-");

            console.log("STARTDATE", startDate);
            console.log("ENDDATE", endDate);
            _val.value = `Od: ${startDate[2]}.${startDate[1]}.${startDate[0]}, do: ${endDate[2]}.${endDate[1]}.${endDate[0]}`
          }
          else {
            if (_value != '') {
              _val.value = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, val.parameter, _value);
            } else {
              _val.value = _value;
            }
          }

          console.log("_val.value", _val.value);

          let _parameter = _.filter(_this.$t('text.documentSearch.documentSearchDetailed.searchableFields'), {id: val.parameter});
          if (_parameter.length > 0) {
            _val.parameter = _parameter[0].description;
          }
        });

        if(data.query.explanationList.length === 0) {
          data.query.explanationList = [{operator: '', parameter: '', value: '-'}];
        }

      }

      if (_this.reportType === 'REVIZIJSKA_SLED_SIFRANTI') {

        if (!this.selectedRegisterOption) {
          Vue.$toast.open({
            message: this.$t('text.generateReportButton.selectedRegisterOptionIsRequiredFieldToast.message'),
            type: 'error',
            position: 'top-right'
          });
          return;
        }

        data.sifrantAuditReportType = this.selectedRegisterOption;
        data.description = ""; // hack for not showing description input popup
      }

      if (_this.reportType === 'REVIZIJSKA_SLED_UPORABNIK') {

        if (!this.user) {
          Vue.$toast.open({
            message: this.$t('text.generateReportButton.selectedUserIsRequiredFieldToast.message'),
            type: 'error',
            position: 'top-right'
          });
          return;
        }

        let _data = {
          "reportType": data.reportType,
          "auditReportQuery": {
            "user": this.user,
            "from": _this.moment(data.from).valueOf(),
            "to": _this.moment(data.to).valueOf()
          },
          "description": "", // hack for not showing description input popup
        }
        data = _data;
      }

      if (_this.reportType === 'REVIZIJSKA_SLED_NEOMEJENO') {
        let _data = {
          "reportType": data.reportType,
          "auditReportQuery": {"from": _this.moment(data.from).valueOf(), "to": _this.moment(data.to).valueOf()},
          "description": "", // hack for not showing description input popup
        }
        data = _data;
      }

      if (_this.reportType === 'REVIZIJSKA_SLED_ZADEVA') {

        if (!this.stevilkaZadeve) {
          Vue.$toast.open({
            message: this.$t('text.generateReportButton.selectedStevilkaZadevaIsRequiredFieldToast.message'),
            type: 'error',
            position: 'top-right'
          });
          return;
        }

        let _data = {
          "reportType": data.reportType,
          "auditReportQuery": {
            "auditSearchQuery": {"stevilkaZadeve": this.stevilkaZadeve},
            "from": _this.moment(data.from).valueOf(),
            "to": _this.moment(data.to).valueOf()
          },
          "description": "", // hack for not showing description input popup
        }
        data = _data;
      }

      if (_this.reportType === 'REVIZIJSKA_SLED_RAZRED') {

        if (!this.selectedClassificationClass) {
          Vue.$toast.open({
            message: this.$t('text.generateReportButton.selectedClassificationClassIsRequiredFieldToast.message'),
            type: 'error',
            position: 'top-right'
          });
          return;
        }

        let _data = {
          "reportType": data.reportType,
          "auditReportQuery": {
            "auditSearchQuery": {"uuid": _this.selectedClassificationClass},
            "from": _this.moment(data.from).valueOf(),
            "to": _this.moment(data.to).valueOf()
          },
          "description": "", // hack for not showing description input popup
        }
        data = _data;
      }

      if (_this.reportType === 'PRETECENI_DATUM') {
        if (!this.date) {
          Vue.$toast.open({
            message: this.$t('text.generateReportButton.dateIsRequiredFieldToast.message'),
            type: 'error',
            position: 'top-right'
          });
          return;
        }

        console.log("data", data);

        let _data = {
          "reportType": data.reportType,
          "date": _this.date,
          "description": _this.description,
          "courtId": _this.sodisce,
        }

        let sort = _this.serverParams.sort;
        _.map(sort, function (val, key) {
          sort[key] = {
            ascending: val.ascending,
            field: val.field,
          };
        });

        _data.query = {
          aftsQuery: _this.query ? _this.query : "",
          sortList: sort,
          explanationList: [],
        };

        data = _data;
      }


      _this.$globalFunctions.generateReport(data);
      _this.closeModal();
    },

    translateOperator(operator) {
      switch (operator) {
        case "AND":
          return this.$t('text.globals.and');
          break;
        case "OR":
          return this.$t('text.globals.or');
          break;
        case "NOT":
          return this.$t('text.globals.not');
          break;
      }
    },

    async beforeGenerateReport(item) {
      const _this = this;

      console.log("item", item);

      _this.reportType = item.reportType;
      _this.description = null;

      if (item.reportType === 'GRADIVO_ROKI_HRAMBE' || item.reportType === 'GRADIVO_DOSTOP' || item.reportType === 'GRADIVO' || item.reportType === 'OIIU_KANDIDATI_BRISANJE') {
        // detect if no documents are selected
        if (_this.$store.getters.getSelectedDocuments.length === 0 && (_this.guiLocation === "GRADIVO_IZBOR" || item.reportType === 'OIIU_KANDIDATI_BRISANJE' || (_this.guiLocation === "GRADIVO_ISKANJE" && (item.reportType === 'GRADIVO' || item.reportType === 'GRADIVO_ROKI_HRAMBE' || item.reportType === 'GRADIVO_DOSTOP')))) {
          swal(
              this.$t('text.generateReportButton.documentNotSelectedSwal.message1'),
              this.$t('text.generateReportButton.documentNotSelectedSwal.message2'),
              "error",
              {dangerMode: true}
          );
          return;
        }

        if (_this.$store.getters.getSelectedDocuments.length > 5000) {
          swal(
              this.$t('text.generateReportButton.tooManyDocuments.message1'),
              this.$t('text.generateReportButton.tooManyDocuments.message2'),
              "error",
              {dangerMode: true}
          );
          return;
        }
      }

      if (item.reportType === 'REVIZIJSKA_SLED_RAZRED') {
        _this.isLoadingInModal = true;
        await _this.getClassificationPlan();
        _this.isLoadingInModal = false;
      }

      _.map(_this.permissions, function (val, idx) {
        if (_this.courts.indexOf(val.court) < 0) {
          _this.courts.push(val.court);
        }
      });

      let allCourts = [];
      _.each(_this.allMetadataOptions, function (val, key) {
        let property = val.property;

        if (property === "EH:sodisce") {
          allCourts = val.body;
        }
      });

      let filteredCourts = [];
      _.each(_this.options_sodisce, function (item){
        if(_this.courts.indexOf(item.id) > -1) {
          filteredCourts.push(item);
        }
      });
      console.log("filteredCourts", filteredCourts);
      _this.options_sodisce = filteredCourts;

      console.log("this.courts", _this.courts);
      console.log("allCourts", allCourts);

      if (_this.courts.indexOf(null) > -1 || _this.courts.indexOf("ALL") > -1) {
        // if (
        //     _this.$globalFunctions.checkForPermission("ARHIV_RS") ||
        //     _this.reportType === "OIIU_BRISANJE" ||
        //     _this.reportType === "NAPAKE"
        // ) {
        //     _this.$refs["setCourt-modal"].show();
        // } else {
        //     _this.generateReport();
        // }
        _this.$refs["setCourt-modal"].show();
      } else {

        // retrieve court inforamtion from search filters
        if (_this.guiLocation === "GRADIVO_IZBOR" || _this.guiLocation === "GRADIVO" || _this.guiLocation === "GRADIVO_ISKANJE" ||  _this.guiLocation === "OIIU_PRETECENO" || _this.guiLocation === "OIIU_PRETECENO" || _this.guiLocation === "PRETECENI_DATUM" || _this.guiLocation === "OIIU_DODELJENO" || _this.guiLocation === "OIIU_PREDLAGANO_UNICENJE" || _this.guiLocation === "BRISANJE" || _this.guiLocation === "OIIU_PRIMERNO_ARHIV" || _this.guiLocation === "OIIU_PREGLEDANO_ARHIV" || _this.guiLocation === "OIIU_KANDIDATI_IZROCITEV") {
          let parsedCourtValue = null;


          console.log("_this.filtersQuery", _this.filtersQuery);

          _.map(_this.filtersQuery, function (val, idx) {
            if (val.includes("EH:sodisce:")) {
              parsedCourtValue = val.substring(
                  val.indexOf('"') + 1,
                  val.length - 1
              );
            }
          });

          console.log("-------> ", parsedCourtValue, this.guiLocation);

          if (parsedCourtValue !== null) {
            _this.selectedCourt = parsedCourtValue;
          } else if (_this.context && _this.context.facetsFields && _.find(_this.context.facetsFields, {"label": "sodišče"}).buckets.length === 1) {
            let court = _.find(_this.context.facetsFields, {"label": "sodišče"}).buckets[0].filterQuery;
            _this.selectedCourt = court.substring(
                court.indexOf('"') + 1,
                court.length - 1
            );
          } else { //if(this.guiLocation !== 'PRETECENI_DATUM') {
            swal(
                this.$t('text.generateReportButton.courtNotSelectedSwal.message1'),
                this.$t('text.generateReportButton.courtNotSelectedSwal.message2'),
                "error",
                {dangerMode: true}
            );
            return;
          }
        }

        _this.$refs["setCourt-modal"].show();
      }
    },

    async getClassificationPlan() {
      const _this = this;

      axios
          .get(config.alfrescoServiceApi + "rma/admin/ehramba/fileplan")
          .then(res => {
            let options = {
              compact: true
            };

            let classificationPlanJs = convert.xml2js(res.data, options);
            console.log("classificationPlanJs", classificationPlanJs);
            this.classificationPlan = this.formatObject(
                classificationPlanJs,
                "fromServer"
            );
            this.$store.dispatch(
                "setClassificationPlan",
                this.classificationPlan
            );
            this.isLoadingClassificationPlan = false;
            console.log("this.classificationPlan", this.classificationPlan);
          })
          .catch(error => {
            console.error(error);
          });
    },

    // formatira pretvorjen Klasifikacijski načrt v ustrezno strukturo, ki nam bo olajšala delo z njo
    // we adjust the classification plan structure, so it is easier to work with later
    formatObject(classificationPlanJs, typeOfImport) {
      let classificationPlanFormatted = [];

      // če je root element objekt, ga spremenimo v array
      // if the root class (root.item) is an object, we convert it to an array

      if (!classificationPlanJs.root.item) {
        return classificationPlanFormatted;
      }

      if (classificationPlanJs.root.item.length == null) {
        let itemRootArray = [];
        itemRootArray.push(classificationPlanJs.root.item);
        classificationPlanJs.root.item = itemRootArray;
      }

      if (classificationPlanJs.root.item.length > 0) {
        classificationPlanJs.root.item = _.sortBy(
            classificationPlanJs.root.item,
            [
              function (o) {
                return o.classificationLabel._text;
              }
            ]
        );
      }

      for (let i = 0; i < classificationPlanJs.root.item.length; i++) {
        let obj = this.formatObjectRec(
            classificationPlanJs.root.item[i],
            1,
            "none",
            typeOfImport
        );

        _.map(obj, function (v, k) {
          if (k == "item") {
            obj[k] = _.sortBy(v, [
              function (o) {
                return o.classificationLabel;
              }
            ]);
          }
        });
        classificationPlanFormatted.push(obj);
      }

      return classificationPlanFormatted;
    },

    formatObjectRec(
        classificationPlanJsItem,
        depth,
        parentClassLabel,
        typeOfImport
    ) {

      let formattedClass = {
        alfrescoId: null,
        classificationLabel: null,
        containsRecords: false,
        classificationLabelName: null,
        classificationLabelDescription: null,
        duplicatedClassLabels: [],
        vpisnik: [],
        povezaniSistemi: [],
        usageEndDate: null,
        creationDate: null,
        parentClass: null,
        item: [],
        errors: {
          classificationLabelNameDuplicateError: null,
          classificationLabel: {
            missing: null,
            valueError: null
          },
          classificationLabelName: null,
          classificationLabelDescription: null,
          povezaniSistemi: null,
          vpisnik: null
        },
        structure: {
          isOpen: null,
          checked: null,
          depth: null,
          changed: false,
          match: false
        }
      };

      if (typeOfImport === "fromServer") {
        formattedClass.structure.changed = false;
      } else if (typeOfImport === "fromXml") {
        formattedClass.structure.changed = true;
      }

      if (
          classificationPlanJsItem.classificationLabel &&
          classificationPlanJsItem.classificationLabel._text
      ) {
        formattedClass.classificationLabel =
            classificationPlanJsItem.classificationLabel._text;
      }

      if (
          classificationPlanJsItem.classificationLabelName &&
          classificationPlanJsItem.classificationLabelName._text
      ) {
        formattedClass.classificationLabelName =
            classificationPlanJsItem.classificationLabelName._text;
      }

      if (
          classificationPlanJsItem.classificationLabelDescription &&
          classificationPlanJsItem.classificationLabelDescription._text
      ) {
        formattedClass.classificationLabelDescription =
            classificationPlanJsItem.classificationLabelDescription._text;
      }

      if (
          classificationPlanJsItem.alfrescoId &&
          classificationPlanJsItem.alfrescoId._text
      ) {
        formattedClass.alfrescoId = classificationPlanJsItem.alfrescoId._text;
      }

      if (
          classificationPlanJsItem.containsRecords &&
          classificationPlanJsItem.containsRecords._text
      ) {
        formattedClass.containsRecords =
            classificationPlanJsItem.containsRecords._text === "true";
      }


      // we check if the imported dates are valid (if not, we remove them)

      if (
          classificationPlanJsItem.usageEndDate &&
          classificationPlanJsItem.usageEndDate._text
      ) {
        let usageEndDateMoment = this.moment(
            classificationPlanJsItem.usageEndDate._text,
            "DD-MM-YYYY"
        );

        if (usageEndDateMoment.isValid()) {
          formattedClass.usageEndDate =
              classificationPlanJsItem.usageEndDate._text;
        }
      }

      // i think that we should ignore/throw out the parentClass tag, because it is easily set when importing the plan
      /*
                if(classificationPlanJsItem.parentClass && classificationPlanJsItem.parentClass._text) {
                    formattedClass.parentClass = classificationPlanJsItem.parentClass._text;
                }
                */

      // we set the parent class because it is useful to have it for moving, adding new classes ...
      formattedClass.parentClass = parentClassLabel;

      //the  first two levels of the classification plan should be opened when we import the plan

      formattedClass.structure.isOpen = depth === 1 || depth === 2;
      formattedClass.structure.depth = depth;
      formattedClass.structure.checked = true;

      if (typeOfImport === "fromServer") {
        if (
            classificationPlanJsItem.creationDate &&
            classificationPlanJsItem.creationDate._text
        ) {
          formattedClass.creationDate =
              classificationPlanJsItem.creationDate._text;
        }
      } else {
        // creation date attribute is added
        console.log(" // creation date attribute is added  // creation date attribute is added  // creation date attribute is added");
        let today = new Date();
        let dd = String(today.getDate()).padStart(2, "0");
        let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        let yyyy = today.getFullYear();
        today = dd + "-" + mm + "-" + yyyy;

        formattedClass.creationDate = today;
      }

      // if there is no children we put an empty array

      if (!classificationPlanJsItem.item) {
        classificationPlanJsItem.item = [];
      }

      // if there is only one child, the parser interprets it as an object, so we need to convert it to an array
      else if (classificationPlanJsItem.item.length == null) {
        let itemArray = [];
        itemArray.push(classificationPlanJsItem.item);
        classificationPlanJsItem.item = itemArray;
      }

      //finally, we recursively call the function on all the children

      for (let i = 0; i < classificationPlanJsItem.item.length; i++) {
        formattedClass.item.push(
            this.formatObjectRec(
                classificationPlanJsItem.item[i],
                depth + 1,
                formattedClass.classificationLabel,
                typeOfImport
            )
        );
      }

      return formattedClass;
    },
  },
};
</script>
>



// WEBPACK FOOTER //
// src/components/GenerateReportButton.vue